export default "{\n    \"callback\": \"Callback\"\n}\n"